import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";

export const StyledButton = styled((props: ButtonProps) => (
  <Button {...props} />
))(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  padding: "6px 10px",
}));
